export default "__VITE_ASSET__CjYEwe82__"